import { render, staticRenderFns } from "./CCMDiagnosisViewDialog.vue?vue&type=template&id=1c54a282"
import script from "./CCMDiagnosisViewDialog.vue?vue&type=script&lang=js"
export * from "./CCMDiagnosisViewDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports